// src/utils/haptics.js

/**
 * Triggers a haptic feedback vibration if the browser supports it.
 * @param {('light'|'medium'|'heavy'|'success'|'warning'|'error'|number)} intensity - The intensity of the vibration.
 * Can be a predefined string or a number in milliseconds.
 */
export const triggerHaptic = (intensity = 'light') => {
  if (typeof window !== 'undefined' && 'vibrate' in navigator) {
    try {
      let pattern;
      switch (intensity) {
        case 'light':
          pattern = [50];
          break;
        case 'medium':
          pattern = [100];
          break;
        case 'heavy':
          pattern = [200];
          break;
        case 'success':
          pattern = [50, 100, 50];
          break;
        case 'warning':
          pattern = [100, 50, 100];
          break;
        case 'error':
          pattern = [100, 50, 100, 50, 100];
          break;
        default:
          pattern = typeof intensity === 'number' ? [intensity] : [50];
          break;
      }
      navigator.vibrate(pattern);
    } catch (error) {
      console.warn("Haptic feedback failed:", error);
    }
  }
};
